// extracted by mini-css-extract-plugin
export default {"taskPage_section":"TaskPage_taskPage_section__eYzWX","task_text":"TaskPage_task_text__QpJVu"};